import React, { ReactElement } from "react";
import Loading from "../../../../ui-components/loading/loading";
import { Popover } from '../../../../ui-components/popover/popover';

interface InfoTypeTileContentProps {
    isLoading: boolean;
    title: string;
    value: string | number | ReactElement;
    legendDescription?: string;
    onApply?: any
}

export const InfoTypeTileContent: React.FC<InfoTypeTileContentProps> = (props) => {
    return (
        <div className="content__info">
            <div
                className="content__info__values"
            >
                {props.isLoading ?
                    <Loading isLoading={true} /> :
                    <div className="content__info__values__info">{props.value}</div>
                }
                <Popover values={<div className="terminal-summary__tooltip">{props.legendDescription}</div>} />
            </div>
            <div className="title">
                <div className="title__heading">
                    {props.title}
                </div>
                {(!!props.onApply && !props.isLoading) && <div
                    className="title__apply-btn"
                    onClick={() => props.onApply()}
                >Apply
                </div>
                }
            </div>
        </div>
    )
};